(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfMessageWriter', function() {
    return {
      restrict: 'E',
      template: "<div dusk='message_writer_output' class='alert animate-show' ng-show='alert_message || alert_details.length' ng-class=\"{ 'alert-success': alert_type === 'success', 'alert-info':    alert_type === 'info', 'alert-error':   alert_type === 'error', 'absolute-errorDiv': absolute_errors, }\"> <span ng-bind='alert_message'></span> <ul ng-if='alert_details && alert_details.length'> <li ng-repeat='detail in alert_details' ng-bind='detail'></li> </ul> </div>"
    };
  });

}).call(this);
